<p-card>
  <ng-template pTemplate="header">
    <div class="p-card-title">
      <h5>Create Incident Report</h5>
    </div>
  </ng-template>

  <div class="">

    @if (!requestLink()) {
      <div class="form">
        <div class="field-radiobutton">
          <p-radioButton name="entrymethod" inputId="entryhere" value="here" [(ngModel)]="selectedEntryMethod">
          </p-radioButton>
          <label for="entryHere">Fill out on this Device</label>
        </div>
        <div class="field-radiobutton">
          <p-radioButton name="entrymethod" inputId="entryLink" value="link" [(ngModel)]="selectedEntryMethod">
          </p-radioButton>
          <label for="entryLink">Generate a sharable a Link</label>
        </div>
        <div>
          @if (selectedEntryMethod() === 'here') {
            <h5>I Am...</h5>
          }
          @if (selectedEntryMethod() === 'link') {
            <h5>This link is for...</h5>
          }
          <p-select class="mb-1" [options]="reportTypes" [(ngModel)]="selectedReportType" optionLabel="name">
          </p-select>
        </div>
        @if (selectedEntryMethod() === 'link') {
          <div class="pb-4">
            <div>
              <label class="form-label" for="name">Name</label>
              <input pInputText type="text" name="name" id="name" [(ngModel)]="name" class="form-control" required />
            </div>
            <div style="display: none">
              <label class="form-label" for="email">Email</label>
              <input type="text" name="email" id="email" class="form-control" [(ngModel)]="email" />
            </div>
            <div class="mb-1">
              <label class="form-label" for="incidentDate">Incident Date</label>
              <p-datepicker fluid [(ngModel)]="incidentDate" name="incidentDate" id="incidentDate" [showTime]="true"
                hourFormat="12" [hideOnDateTimeSelect]="false" [required]="true" [showIcon]="true"
              class="block w-full"></p-datepicker>
            </div>
          </div>
        }
        <button pButton class="block" label="Create" class="btn btn-primary" (click)="reportTypeSelected()"></button>
      </div>
    }

    @if (requestLink()) {
      <div>
        <p>If you need to generate a new link for this report, you may do so in Mission Control
          under Trips/OPS->Incidents->My Submitted Reports
        </p>
        <p>Please copy the link below and send it to the person who needs to fill out the incident report.</p>
        <p-message styleClass="w-full" severity="success">
          <div class="grid grid-cols-12 gap-4 w-full p-8">
            <div class="col-span-12 md:col-span-6 wrap link-container">
              {{requestLink()}}
            </div>
            <div class="col-span-12 md:col-span-2">
              <button pButton *ngxClipboardIfSupported ngxClipboard [cbContent]="requestLink()"
              (cbOnSuccess)="onLinkCopied()">Copy Link</button>
            </div>
            @if (linkCopied()) {
              <div class="col-span-12">Link copied to clipboard</div>
            }
          </div>
        </p-message>
      </div>
    }

  </div>
</p-card>